
export const DRAWER_WIDTH = 250;